module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/8-f43692587750d72d76425d10e171ebd2.jpg";